import hatsApi from '@/services/hatsApi'

export default {
  getInfo (filter) {
    return hatsApi().get(`/operational/reservation-line-extra?filter=${JSON.stringify(filter)}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/ReservationLineExtra.js